module.exports = __webpack_public_path__ + "img/yijieqing.4c426993.png";